export { default } from './ColumnChartWidgetScale';
